<template>
  <div class="container">
    <div class="mirror-wrapper">
      <div class="mirror-wrapper-background">
        <v-row class="mirror-wrapper--menu-date">
          <v-col cols="12" sm="6" md="4">
            <v-menu
              v-model="initialDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="initialDateFormatted"
                  label="Data inicial"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :disabled="loadingSystemHistoricMirror"
                  filled
                  hide-details
                />
              </template>
              <v-date-picker
                v-model="initialDate"
                @input="initialDateMenu = false"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-menu
              v-model="finalDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="finalDateFormatted"
                  label="Data final"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  filled
                  :disabled="!initialDate || loadingSystemHistoricMirror"
                  hide-details
                />
              </template>
              <v-date-picker
                v-model="finalDate"
                @input="finalDateMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </div>
      <Error
        v-if="!loadingSystemHistoricMirror && !filterPlaceAndFolder.length"
        :textTitle="
          'Tão <span>vazio</span> por aqui... <br/>Onde estão as <span>espelhos</span>?!'
        "
        textDescription="Por favor, selecione alguma gaveta no filtro."
        :imageTitle="'detective'"
        style="height: 300px"
        class="empty-search"
      />
      <Error
        v-else-if="
          !loadingSystemHistoricMirror &&
            (errorGetMirrorHistoric || systemHistoricMirror.length === 0)
        "
        :textTitle="
          'Tão <span>vazio</span> por aqui... <br/>Onde estão as <span>espelhos</span>?!'
        "
        :textDescription="'A gaveta selecionada ainda não possui espelhos.'"
        :imageTitle="'detective'"
        style="height: 300px"
        class="empty-search"
      />
      <HistoricMirrorTable
        v-else
        :programs="systemHistoricMirror"
        :isLoading="loadingSystemHistoricMirror"
        :headers="tableHeaders"
        :reorderPermission="reorderPermission"
        :filter="filterDate"
        @load-more="handleLoadSystemHistoricMirror"
      />
    </div>
  </div>
</template>

<script>
import Error from '@/components/shared/Error.vue';
import HistoricMirrorTable from '@/components/mirrors/HistoricMirrorTable.vue';
import { mapState } from 'vuex';
import { dateFormat } from '../../utils/date';
import { debounce } from 'lodash';

export default {
  name: 'MirrorHistoric',
  components: {
    Error,
    HistoricMirrorTable,
  },
  data: () => ({
    initialDateMenu: false,
    initialDate: '',
    initialDateFormatted: '',
    finalDateFormatted: '',
    finalDateMenu: false,
    finalDate: '',
    tableHeaders: [
      {
        text: 'Data',
        align: 'start',
        sortable: false,
        value: 'processing_date',
      },
      {
        text: 'Programa',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      {
        text: 'Origem',
        align: 'start',
        sortable: false,
        value: 'place',
      },
    ],
    reorderPermission: true,
    filterPlaceAndFolder: [],
    queryStringFilter: '',
  }),

  methods: {
    formatDate(date) {
      if (!date) return null;
      return dateFormat(date);
    },

    handleLoadSystemHistoricMirror() {
      this.$store.dispatch('mirror/setLoadingSystemHistoricMirror');
      this.loadSystemHistoricMirror();
    },

    loadSystemHistoricMirror: debounce(function() {
      this.$store.dispatch('mirror/getSystemHistoricMirror', {
        places_and_folders: this.filterPlaceAndFolder,
        from_date: this.formattedFromDate,
        to_date: this.formattedToDate,
      });
    }, 1500),

    resetControlSystemHistoricMirror() {
      this.$store.dispatch('mirror/resetControlSystemHistoricMirror');
    },
  },

  created() {
    this.filterPlaceAndFolder = this.$route.query.folders || [];
    this.resetControlSystemHistoricMirror();
  },

  watch: {
    $route() {
      this.filterPlaceAndFolder = this.$route.query.folders;
      if (this.filterPlaceAndFolder && this.filterPlaceAndFolder.length) {
        this.resetControlSystemHistoricMirror();
        this.handleLoadSystemHistoricMirror();
      } else {
        this.resetControlSystemHistoricMirror();
      }
    },
    initialDate() {
      this.initialDateFormatted = this.formatDate(this.initialDate);
      if (this.initialDate && this.finalDate) {
        this.resetControlSystemHistoricMirror();
        this.handleLoadSystemHistoricMirror();
      }
    },
    finalDate() {
      this.finalDateFormatted = this.formatDate(this.finalDate);
      this.resetControlSystemHistoricMirror();
      this.handleLoadSystemHistoricMirror();
    },
  },

  computed: {
    ...mapState({
      systemHistoricMirror: state => state.mirror.systemHistoricMirror,
      loadingSystemHistoricMirror: state =>
        state.mirror.loadingSystemHistoricMirror,
      errorGetMirrorHistoric: state => state.mirror.errorGetMirrorHistoric,
    }),
    filterDate() {
      return {
        fromDate: this.formattedFromDate,
        toDate: this.formattedToDate,
      };
    },
    formattedFromDate() {
      if (!this.initialDate) return undefined;
      return new Date(`${this.initialDate} 00:00:00`).toISOString();
    },
    formattedToDate() {
      if (!this.finalDate) return undefined;
      return new Date(`${this.finalDate} 23:59:59`).toISOString();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh !important;
  overflow-y: hidden;

  &.side-panel {
    width: calc(100% - 400px);
    margin: 0 0 0 auto;
  }
}

.mirror-wrapper {
  margin-top: 88px !important;
  height: 100vh;
  overflow-y: hidden;

  background: #f5f5f5;

  font-family: 'globotipo' !important;
}

.mirror-wrapper--menu-date {
  padding: 0 16px;
}

::v-deep .v-input {
  .v-input__control {
    .v-input__slot {
      border-radius: 5px !important;
      background: #fff !important;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

      .v-text-field__slot {
        .v-label--active {
          left: 0px !important;
        }

        input {
          padding: 10px 16px !important;
        }
      }

      &::before,
      &::after {
        border: none !important;
      }
    }
  }
}

.mirror-wrapper-background {
  background: #fff;
  width: calc(100% - 32px);
  margin: 16px auto;
  border-radius: 4px;
}
</style>
